import React from 'react'
import classes from './Header.module.css'
import { Link, useNavigate } from 'react-router-dom'
import { toastError } from '../../utils/globalHelper'
import Logo from '../UI/Logo'
import { 
    Link as ChakraLink, Flex, Grid, Image, Text, Menu, MenuButton, MenuList, MenuItem, useToast, MenuDivider,
} from '@chakra-ui/react'
import { AuthService } from '../../API/AuthService'
import { useGlobalStore } from '../../store/globalStore'
import { useChangeContextModalStore } from '../../store/modalsStore'
import RoleTag from '../UI/RoleTag'

function Header() {
    const toast = useToast()
    const navigate = useNavigate()
    const user = useGlobalStore(state => state.user)
    const setUser = useGlobalStore(state => state.setUser)
    const contextModalDisclosure = useChangeContextModalStore(state => state.disclosure)

    const onLogout = async () => {
        const response = await AuthService.logout()
        if (response.status === 204) {
            navigate("/auth")
            setUser(null)
            return
        }
        toast(toastError('Не удалось выйти'))
    }

    return (
        <Grid className={classes.container}>
            <ChakraLink fontSize="lg" as={Link} to="/"><Logo /></ChakraLink>
            <Flex className={classes.user}>
                {user?.active_context?.role &&
                <RoleTag
                    role={user.active_context.role}
                    colorScheme='orange'
                />}
                <Text>{`${user.lastname} ${user.firstname}`}</Text>
                <Menu>
                    <MenuButton maxW='38px'>
                        <Image
                            src={user.avatar ? user.avatar : 'avatar.png'}
                            alt='Avatar'
                        />
                    </MenuButton>
                    <MenuList>
                        <MenuItem onClick={() => navigate('/profile')}>
                            Мой профиль
                        </MenuItem>
                        {
                        user?.contexts?.length && contextModalDisclosure
                        ?
                        <MenuItem onClick={contextModalDisclosure.onOpen}>
                            Сменить контекст
                        </MenuItem>
                        :
                        <></>
                        }
                        <MenuDivider />
                        <MenuItem color="red" onClick={onLogout}>
                            Выйти
                        </MenuItem>
                    </MenuList>
                </Menu>
            </Flex>
        </Grid>
    )
}

export default Header
